module.exports = __webpack_public_path__ + "static/njsetyy-7a3d6eab810f588ea92cfe057a3c22bc.jpg";